import { fmtTimeOrDate } from "@/lib/format";
import { PriorityChip } from "./PendingQueue";

export function FinishedStrip({ items, selectedId, onSelect, onSearch }) {
  return (
    <section className="pane h-full" data-testid="finished-pane">
      <div className="pane-head">
        <span className="overline-label">Recently Finished</span>
        <button data-testid="finished-search-link" onClick={onSearch} className="text-[11px] text-primary hover:underline">Search all history →</button>
      </div>
      <div className="flex-1 min-h-0 overflow-auto">
        {items.length === 0 ? <div className="p-3 text-xs text-muted-foreground">No finished calls yet.</div> : items.map((inc) => (
          <div key={inc.id} data-testid={`finished-row-${inc.incident_number}`} onClick={() => onSelect(inc.id)}
            className={`row-hover cursor-pointer flex items-center gap-2 px-2 py-1 border-b border-border/60 text-xs ${inc.id === selectedId ? "row-selected" : ""}`}>
            <PriorityChip priority={inc.priority} compact />
            <span className="mono font-semibold">{inc.incident_number}</span>
            <span className="mono text-muted-foreground whitespace-nowrap">{fmtTimeOrDate(inc.finished_at)}</span>
            <span className="font-medium truncate">{inc.call_type_name}</span>
            <span className="text-muted-foreground truncate flex-1">{inc.location_raw}</span>
            <span className="chip border-slate-500/40 text-slate-600 dark:text-slate-300">{inc.disposition_label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
